import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/service/auth.service';

export const RequestInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.getCurrentUser();

  // Capture the API endpoint (including query parameters)
  const apiEndpoint = req.urlWithParams;

  // Capture the current route; fallback if Router snapshot url is empty
  const currentRoute = router.routerState?.snapshot?.url || `${window.location.pathname}${window.location.search}${window.location.hash}`;

  // Ensure the body is an object or default to an empty object
  const body = typeof req.body === 'object' && req.body !== null ? req.body : {};

  const userPosition = authService.getUserPosition()

  // Clone the request and modify the body

  const modifiedReq = req.url.includes('authenticate')

    ? req
    : req.clone({
      body: {
        ...body, // Spread the existing body safely
        filiale_id: user?.filiale_id ?? null, // Add `filiale_id`
        user_id: user?.id ?? null, // Add `user_id`
        groupe_id: user?.groupe_id ?? null, // Add `user_id`
        hotel_id: user?.hotel_id,
        page_route: currentRoute,
        request_url: apiEndpoint,
        ...(userPosition?.latitude !== undefined && userPosition?.longitude !== undefined && {
          latitude: userPosition.latitude,
          longitude: userPosition.longitude,
        }),
      },
    });

  return next(modifiedReq);
};
